import { render } from "./DisputePage.vue?vue&type=template&id=2bd1cfa2&scoped=true"
import script from "./DisputePage.vue?vue&type=script&lang=js"
export * from "./DisputePage.vue?vue&type=script&lang=js"

import "./DisputePage.vue?vue&type=style&index=0&id=2bd1cfa2&lang=css"
import "./DisputePage.vue?vue&type=style&index=1&id=2bd1cfa2&lang=css"
import "./DisputePage.vue?vue&type=style&index=2&id=2bd1cfa2&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd1cfa2"]])

export default __exports__